import React from 'react';
// import { create } from 'jss';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { StylesProvider, createGenerateClassName } from '@material-ui/styles';

import Configuration from './configuration';
import {
  APP_TYPE,
} from './services/ViewService';

// Allow CSS customization on Material-UI components
// https://material-ui.com/customization/css-in-js/
const styleNode = document.createComment('insertion-point-jss');
document.head.insertBefore(styleNode, document.head.firstChild);

// Generate classnames without number suffixes for our SCSS to apply on Material UI classnames
// http://cssinjs.org/js-api/?v=v9.8.7#generate-your-own-class-names
// const generateClassName = (rule, sheet) => {
//    return `${sheet.options.classNamePrefix}-${rule.key}`;
// };
// const jss = create(jssPreset());
// jss.options.insertionPoint = 'insertion-point-jss';

// const generateClassName = createGenerateClassName({
//   productionPrefix: 'c',
// });

// const generateClassName = () => (rule, sheet) => {
//   console.log('generate classname');
//   console.log(rule, sheet);
//     return `${sheet.options.classNamePrefix}-${rule.key}`;
// };
const generateClassName = createGenerateClassName({});

// Allows us to use our own dialog to confirm when transitioning routes
function getUserConfirmation(dialogKey, callback) {
  const dialogTrigger = window[dialogKey];

  if (dialogTrigger) {
    // pass the callback to delegate
    // to the invoked dialog
    dialogTrigger(callback);
  } else {
    // eslint-disable-next-line no-alert
    const allowTransition = window.confirm(dialogKey);
    callback(allowTransition);
  }
}

// Icons visible at:
// https://material.io/tools/icons/?style=baseline

const BaseRoot = (rootProps) => {
  const cfg = new Configuration(rootProps);
  const App = cfg.getViewService().getComponent(APP_TYPE);
  return (
    <StylesProvider generateClassName={generateClassName} injectFirst>
      <Router getUserConfirmation={getUserConfirmation}>
        <Switch>
          <Route render={props => <App {...rootProps} {...props} configuration={cfg} />} />
        </Switch>
      </Router>
    </StylesProvider>
  );
};

export default BaseRoot;
